import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography } from "@mui/material";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { generateSlotUtilizationMetrics } from '../../utilityFunctions/DataloveUtil';
import Swal from 'sweetalert';
import CustomLoader from "../../components/CustomLoader";

export default function SlotUtilizationChart(props) {
    const { loginUser } = props;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [utilizationRate, setUtilizationRate] = useState(0);

    useEffect(() => {
        const fetchSlotUtilizationMetrics = async () => {
            setLoading(true);
            const slotMetrics = await generateSlotUtilizationMetrics(loginUser.jwtToken);
            setLoading(false);

            if (!slotMetrics) {
                Swal({
                    title: "Error",
                    text: "Failed to fetch slot utilization metrics",
                    icon: "error",
                    button: "Ok",
                });
                return;
            }

            // Calculate utilization rate as percentage
            const rate = slotMetrics.utilizationRate || 0;
            setUtilizationRate(rate * 100);

            // Create data for gauge chart
            const gaugeData = [
                { name: 'Utilized', value: rate },
                { name: 'Available', value: 1 - rate }
            ];

            setData(gaugeData);
        };
        fetchSlotUtilizationMetrics();
    }, [loginUser.jwtToken]);

    // Colors for the gauge
    const COLORS = ['#4a3596', '#f5f5f5'];

    return (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%", height: "100%" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: {xs: "start", sm: "start", md: "center"}, width: "95%", height: "90%", textAlign: "center", marginTop: { xs: "4.5rem", sm: "2rem", md: "0" } }}>
                {loading ? (
                    <CustomLoader />
                ) : (
                    <Grid container direction="row" spacing={1} sx={{display: "flex", justifyContent: "center"}}>
                        <Grid item xs={12}>
                            <Typography variant="h4" sx={{ marginTop: "2rem", fontWeight: "bold" }}>Slot Utilization Rate</Typography>
                        </Grid>
                        {data && data.length > 0 ? (
                            <Grid item xs={12} sx={{width: "100%", height: 400}}>
                                <ResponsiveContainer width="100%" height={400}>
                                    <PieChart>
                                        <Pie
                                            data={data}
                                            cx="50%"
                                            cy="50%"
                                            startAngle={180}
                                            endAngle={0}
                                            innerRadius="60%"
                                            outerRadius="80%"
                                            paddingAngle={0}
                                            dataKey="value"
                                        >
                                            {data.map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                            ))}
                                        </Pie>
                                        <Tooltip formatter={(value, name) => {
                                            if (name === 'Utilized') {
                                                return [`${(value * 100).toFixed(1)}%`, 'Utilization Rate'];
                                            }
                                            return [null, ''];
                                        }} />
                                    </PieChart>
                                </ResponsiveContainer>
                                <Typography variant="h3" sx={{ marginTop: "-12rem", color: "#4a3596", fontWeight: "bold" }}>
                                    {utilizationRate.toFixed(1)}%
                                </Typography>
                                <Typography variant="h6" sx={{ marginTop: "0.5rem" }}>
                                    Slot Utilization Rate
                                </Typography>
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <Typography variant="body1">
                                    No data available.
                                </Typography>                                
                            </Grid>
                        )}
                    </Grid>
                )}           
            </Box>
        </Box>
    );
} 